import React from 'react';
import Section from './Section';
import { SERVICES } from '../constants';
import * as Icons from 'lucide-react';
import { LucideIcon } from 'lucide-react';

const Services: React.FC = () => {
  return (
    <Section id="services" className="bg-neutral-950">
      <div className="flex flex-col md:flex-row justify-between items-end mb-16 md:mb-32 border-b border-white/10 pb-8">
        <div>
          <span className="text-xs uppercase tracking-[0.2em] text-neutral-500 mb-2 block">Onze Expertise</span>
          <h2 className="text-4xl md:text-5xl font-display text-white">SERVICES</h2>
        </div>
        <p className="text-neutral-500 max-w-sm text-right mt-6 md:mt-0 font-light text-sm md:text-base">
          Een selectie van behandelingen gericht op duurzaamheid, correctie en esthetische perfectie.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-l border-t border-white/10">
        {SERVICES.map((service, index) => {
          const IconComponent = (Icons as unknown as Record<string, LucideIcon>)[service.icon] || Icons.HelpCircle;
          
          return (
            <div 
              key={service.id} 
              className="group relative bg-black border-r border-b border-white/10 p-6 md:p-10 hover:bg-neutral-900 transition-colors duration-1000 ease-out"
            >
              <div className="mb-8 md:mb-12 text-neutral-600 group-hover:text-white transition-colors duration-500">
                <IconComponent size={32} strokeWidth={1} />
              </div>
              
              <div className="relative z-10">
                <h3 className="text-lg font-display text-white mb-3 md:mb-4 tracking-widest uppercase">{service.title}</h3>
                <p className="text-neutral-500 text-sm leading-7 group-hover:text-neutral-400 transition-colors font-light">
                  {service.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default Services;